
<button
  mat-button
  [matMenuTriggerFor]="menu"
  type="button"
  (click)="$event.stopPropagation()"
>
  <span>Action</span>
  <!-- <mat-icon class="arrow">expand_more</mat-icon> -->
</button>

<mat-menu #menu="matMenu" xPosition="before" panelClass="menu-container">
  <button mat-menu-item (click)="emit('delete')">Delete</button>
  <button mat-menu-item (click)="emit('copy')">Copy</button>
  <button mat-menu-item (click)="emit('publish')">Publish</button>

</mat-menu>
